import React from 'react';

import getEntityUrl from 'url-constructors/getEntityUrl';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import Anchor from 'components/base/Anchor/Anchor';

import { CompareModes } from 'context/entityContext';

interface IConcertsProps {
  artist: { name: string; entityId: string; entityType: string };
  topic: string;
  compareMode?: CompareModes;
}

const Concerts: React.FC<IConcertsProps> = ({
  artist: { name, entityId, entityType },
  topic,
  compareMode,
}) => {
  return (
    <div>
      <Layout.MaxWidth>
        {compareMode ? (
          <Message>Select an artist to see the events table</Message>
        ) : name && entityId && entityType ? (
          <Message>
            Go to&nbsp;
            <Anchor
              withChevron={false}
              isNewDesign
              to={getEntityUrl({
                entityType,
                entityId,
                topic,
              })}
            >
              {name}&apos;
            </Anchor>
            s artist page to see past and upcoming concerts.
          </Message>
        ) : (
          <div />
        )}
      </Layout.MaxWidth>
    </div>
  );
};

export default Concerts;
